const _excluded = ["rootClose", "placement", "show", "trigger", "triggerTarget", "delayShow", "delayHide", "onHide", "onShow", "getTargetProps", "target", "overlayRef", "offset", "hideArgs"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { useForwardedRef } from '@adsk/alloy-react-helpers';
import { useOverlay } from '@adsk/alloy-react-overlay';
import Tooltip from './Tooltip';
function useTooltip(_ref) {
  let {
      rootClose,
      placement: placementProp,
      show: showProp,
      trigger,
      triggerTarget,
      delayShow,
      delayHide,
      onHide: onHideProp,
      onShow: onShowProp,
      getTargetProps,
      target: targetRef,
      overlayRef,
      offset,
      hideArgs = {
        strategy: 'referenceHidden'
      }
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const isHover = trigger === Tooltip.TRIGGER_EVENTS.HOVER;
  const interactive = triggerTarget === Tooltip.TRIGGER_TARGETS.TOOLTIP;
  const target = useForwardedRef(targetRef || null);
  const {
    show,
    placement,
    targetProps,
    overlayProps,
    arrowProps,
    onShow,
    onHide,
    handleToggle
  } = useOverlay(_objectSpread({
    placement: placementProp,
    show: showProp,
    delayShow,
    delayHide,
    onHide: onHideProp,
    onShow: onShowProp,
    target,
    overlayRef,
    rootClose: rootClose && !isHover,
    offset,
    hideArgs
  }, props));
  const events = {
    onFocus: isHover ? onShow : undefined,
    onBlur: isHover ? onHide : undefined,
    onMouseEnter: isHover ? onShow : undefined,
    onMouseLeave: isHover ? onHide : undefined,
    onClick: !isHover ? handleToggle : undefined
  };
  return {
    show,
    placement,
    interactive,
    targetProps: _objectSpread(_objectSpread({
      ref: targetProps.ref
    }, events), getTargetProps()),
    arrowProps,
    overlayProps: _objectSpread({
      onMouseEnter: interactive ? onShow : undefined,
      onMouseLeave: interactive ? onHide : undefined,
      onClick: event => event.stopPropagation()
    }, overlayProps)
  };
}
export default useTooltip;
//# sourceMappingURL=useTooltip.js.map